import { render } from "./ModalResumenIngresos.vue?vue&type=template&id=3133996c&scoped=true"
import script from "./ModalResumenIngresos.vue?vue&type=script&lang=js"
export * from "./ModalResumenIngresos.vue?vue&type=script&lang=js"

import "./ModalResumenIngresos.vue?vue&type=style&index=0&id=3133996c&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3133996c"]])

export default __exports__